module.exports = __webpack_public_path__ + "img/Weapon_288.b1037f03.png";